import React, { Component } from 'react'
import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'

import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import { DownloadFileIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/DownloadFileIcon'
import { BaseModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/baseModal/BaseModal'

import * as downloadActions from './data/downloadActions'
import { getDownloadCSVModalState } from './data/downloadSelectors'
import DownloadHistoryView from './downloadCSVModal/DownloadCSVHistoryView'
import { RootState } from '../../../data/store'

type OwnDownloadCSVProps = {
  downloadClick?: (...args: any[]) => any
  buttonText?: string
  showDownloadCSVModal?: boolean
  actions?: any
}

type DownloadCSVProps = OwnDownloadCSVProps & typeof DownloadCSV.defaultProps
class DownloadCSV extends Component<DownloadCSVProps> {
  static defaultProps = {
    downloadClick: () => {},
    buttonText: 'CSV',
  }

  render() {
    const DownloadHistory = <DownloadHistoryView downloadClick={this.props.downloadClick} />

    return (
      <div>
        <DefaultButton isOutlined onClick={() => this.props.actions.toggleDownloadCSVModal(true)}>
          <DownloadFileIcon size={20} fill='currentColor' />
          {this.props.buttonText}
        </DefaultButton>
        <BaseModal
          // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          isOpen={this.props.showDownloadCSVModal}
          body={DownloadHistory}
          closeModal={() => this.props.actions.toggleDownloadCSVModal(false)}
        />
      </div>
    )
  }
}
const mapStateToProps = (state: RootState) => {
  return {
    showDownloadCSVModal: getDownloadCSVModalState(state),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ ...downloadActions }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadCSV)
